// @flow

import {Tag} from 'docs/util';
import type {MarkdocTagRegistration} from 'docs/markdoc';

// TODO: Split key type='setup' into a key-preamble component which has support for 'indent'.

function generateSetupComment(language, key) {
  let comment = '//';
  let code = null;

  switch (language) {
    case 'ruby':
      comment = '#';
      code = ["Stripe.api_key = '", key, "'"];
      break;
    case 'python':
      comment = '#';
      code = ["stripe.api_key = '", key, "'"];
      break;
    case 'php':
      code = ["\\Stripe\\Stripe::setApiKey('", key, "');"];
      break;
    case 'java':
      code = ['Stripe.apiKey = "', key, '";'];
      break;
    case 'javascript':
      code = ["const stripe = require('stripe')('", key, "');"];
      break;
    case 'go':
      code = ['stripe.Key = "', key, '"'];
      break;
    case 'dotnet':
    case 'csharp':
      code = ['StripeConfiguration.ApiKey = "', key, '";'];
      break;
  }

  return !code
    ? []
    : [
        comment,
        ' Set your secret key.',
        ' Remember to switch to your live secret key in production.\n',
        comment,
        ' See your keys here: https://dashboard.stripe.com/apikeys\n',
        ...code,
      ];
}

export const KeyToken: MarkdocTagRegistration = {
  tag: 'key',
  component: 'KeyToken',
  selfClosing: true,
  description: "Display the user's API test key",
  localize: false,
  attributes: {
    type: {
      type: String,
      default: 'publishable',
      description: 'Type of key, can be: "publishable", "secret", "setup"',
      matches(config) {
        return ['publishable', 'secret', 'setup'];
      },
    },
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const keys = (config.variables.keys: any);
    const type = attributes.type === 'setup' ? 'secret' : attributes.type;
    const lang = config.variables['$$CodeBlock:language'];
    const key = new Tag(this.tag, {...attributes, value: keys[type], type});

    if (attributes.type !== 'setup') {
      return key;
    }
    return generateSetupComment(lang, key);
  },
};
